import swal from "sweetalert2";
import { getTranslation } from "helpers/common";

const toast = swal.mixin({
  toast: true,
  type: "success",
  position: "top",
  showConfirmButton: false,
  timer: 3000
});

const confirm = swal.mixin({
  type: "warning",
  showCancelButton: true,
  buttonsStyling: false,
  customClass: "cnb-swal",
  confirmButtonClass: "cnb-button primary swal",
  cancelButtonClass: "cnb-button gray swal second",
  cancelButtonText: getTranslation("CANCEL")
});

const alert = swal.mixin({
  type: "info",
  buttonsStyling: false,
  customClass: "cnb-swal",
  confirmButtonClass: "cnb-button primary swal"
});

export default { toast, confirm, alert };
